export const MINUTE_IN_MILLISECONDS = 1000 * 60;
export const HOUR_IN_MILLISECONDS = MINUTE_IN_MILLISECONDS * 60;
